/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Code which indicates a particular low or zero carbon energy source.  This code represents various low or zero carbon energy sources:   1 - Biomass main heating   2 - Biomass community heating   3 - Biomass community heating for some of heat generation   4 - Biomass secondary heating   5 - Geothermal heat source   6 - Community combined heat and power   7 - Ground source heat pump   8 - Water source heat pump   9 - Air source heat pump   10 - Solar water heating   11 - Solar photovoltaics   12 - Wind turbine   13 - Community heat pump   14 - Hydro-electric generation   15 - Micro-CHP   16 - Exhaust air heat pump   17 - Solar-assisted heat pump 
 */
export type SAPLZCEnergySourceCodeUIDTOV0 = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12' | '13' | '14' | '15' | '16' | '17';

export const SAPLZCEnergySourceCodeUIDTOV0 = {
    _1: '1' as SAPLZCEnergySourceCodeUIDTOV0,
    _2: '2' as SAPLZCEnergySourceCodeUIDTOV0,
    _3: '3' as SAPLZCEnergySourceCodeUIDTOV0,
    _4: '4' as SAPLZCEnergySourceCodeUIDTOV0,
    _5: '5' as SAPLZCEnergySourceCodeUIDTOV0,
    _6: '6' as SAPLZCEnergySourceCodeUIDTOV0,
    _7: '7' as SAPLZCEnergySourceCodeUIDTOV0,
    _8: '8' as SAPLZCEnergySourceCodeUIDTOV0,
    _9: '9' as SAPLZCEnergySourceCodeUIDTOV0,
    _10: '10' as SAPLZCEnergySourceCodeUIDTOV0,
    _11: '11' as SAPLZCEnergySourceCodeUIDTOV0,
    _12: '12' as SAPLZCEnergySourceCodeUIDTOV0,
    _13: '13' as SAPLZCEnergySourceCodeUIDTOV0,
    _14: '14' as SAPLZCEnergySourceCodeUIDTOV0,
    _15: '15' as SAPLZCEnergySourceCodeUIDTOV0,
    _16: '16' as SAPLZCEnergySourceCodeUIDTOV0,
    _17: '17' as SAPLZCEnergySourceCodeUIDTOV0
};

